import axiosInstance from "./http";

// 共用获取字典项接口  new-retail/dict/dict/type
export function dictTypeList(data) {
    return axiosInstance({
        method: 'post',
        url: `/new-retail/dict/dict/type/${data}`
    })
}

//  获取试用天数 new-retail/owApi/trialDay
export function trialDay(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/trialDay`,
        params:data
    })
}

// 课程包 /owApi/course/coursePackage
export function coursePackage() {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/course/coursePackage`,
    })
}

// 文章浏览量 new-retail/owApi/article/click?articleId=5
export function articleClick(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/article/click?articleId=${data}`,
    })
}

//线下活动列表 new-retail/owApi/course/activityList
export function courseActivityList(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/course/activityList`,
        params:data
    })
}

// new-retail/owApi/course/activityInfo 线下活动详情
export function activityInfo(id) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/course/activityInfo?id=${id}`,
    })
}

//  获取在售平台会员列表  new-retail/owApi/pay/platformVip
export function platformVip(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/pay/platformVip?type=${data}`,
    })
}

// new-retail/owApi/article/wxArticle 微信文章列表（新闻资讯） 
export function wxArticle(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/article/wxArticle?pageNumber=${data.pageNumber}&pageSize=${data.pageSize}`,
    })
}

// 
export function getLatestVersion_v2(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/getLatestVersion_v2',
        data
    })
}


// 表单申请接口 /new-retail/owApi/form/addApply
export function formAddApply(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/form/addApply',
        data
    })
}
// 获取验证码 new-retail/owApi/sendSmsCode
export function sendSmsCode(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/sendSmsCode?mobile=${data}`,
    })
}
// 官网登录 
export function platformLogin(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/platformLogin',
        data
    })
  };
//   退出 new-retail/owApi/logout
export function logout() {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/logout'
    })
  };
// 官网注册
  export function platformRegister(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/platformRegister',
        data
    })
  };

// 查询 微信支付状态 /new-retail/order/getOrderStatusByOrderNo
export function getOrderStatusByOrderNo(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/order/getOrderStatusByOrderNo',
        data
    })
  };

// 数字产品 查询 支付状态 owApi/techProduct/check/
export function techProductChenk(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/techProduct/check/${data}`,
    })
}

//查询订单信息 owApi/techProduct/orderInfo
export function techProductOrderInfo(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/techProduct/orderInfo/${data}`,
    })
}

// 数字产品分类
export function techProductProductType() {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/techProduct/productType`,
    })
}

//   获取我的企业 new-retail/owApi/pay/selectMyEnterprise
export function selectMyEnterprise(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/pay/selectMyEnterprise',
        params:data
    })
}
// new-retail/owApi/pay/selectEnterpriseAdmin  获取选择企业的企业主
export function selectEnterpriseAdmin(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/pay/selectEnterpriseAdmin',
        params:data
    })
}
// new-retail/owApi/pay/registrationOrder  活动下单 
export function registrationOrder(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/pay/registrationOrder',
        data
    })
  };

//   获取企业部门 /new-retail/owApi/pay/getAllDepByOwnerId
export function getAllDepByOwnerId(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/pay/getAllDepByOwnerId',
        params:data
    })
}
//获取手机对应用户信息  new-retail/owApi/pay/userInfo_byMobile
export function userInfo_byMobile(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/pay/userInfo_byMobile',
        params:data
    })
}

//提交新增数据  new-retail/owApi/pay/saveNrUser
export function saveNrUser(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/pay/saveNrUser',
        data
    })
  };

//  new-retail/owApi/pay/listByActivityAndEnterpriseId 根据企业和活动  获取 企业员工
export function listByActivityAndEnterpriseId(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/pay/listByActivityAndEnterpriseId',
        data
    })
  };

// /new-retail/owApi/pay/listByActivity
export function listByActivity(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/pay/listByActivity',
        data
    })
  };

// 校验确认new-retail/owApi/pay/confirmSubmit
export function confirmSubmit(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/pay/confirmSubmit',
        data
    })
  };

//   new-retail/owApi/pay/buyPlatformVip 需登录）下单
export function buyPlatformVip(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/pay/buyPlatformVip',
        data
    })
  };
//   new-retail/owApi/pay/payPlatformVip 支付 
export function payPlatformVip(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/pay/payPlatformVip',
        data
    })
  };
// 线上课分类 new-retail/owApi/course/courseClassify 
export function courseClassify(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/course/courseClassify',
        params:data
    })
}

// 线上课程列表 new-retail/owApi/course/courseList 
export function courseList(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/course/courseList',
        params:data
    })
}

// 线上课程详情信息 new-retail/owApi/course/courseInfo 
export function courseInfo(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/course/courseInfo',
        params:{courseId:data}
    })
}

// 获取指定展示位置的资源配置列表
export function resourceList(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/resource/list',
        params:data
    })
}

// 获取讲师列表信息 new-retail/owApi/lecturer/list
export function lecturerList(data) {
    return axiosInstance({
        method: 'get',
        url: '/new-retail/owApi/lecturer/list',
        params:data
    })
}
// 获取讲师详情 new-retail/owApi/lecturer/info  lectureId
export function lecturerInfo(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/lecturer/info?lectureId=${data}`,
    })
}
// 获取 讲师线上课程 new-retail/owApi/lecturer/courseList 
export function lecturercourseList(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/lecturer/courseList`,
        params:data
    })
}

// 讲师 活动列表 new-retail/owApi/lecturer/activityList
export function activityList(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/lecturer/activityList`,
        params:data
    })
}

// 讲师  文章列表 new-retail/owApi/lecturer/articleList
export function articleList(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/lecturer/articleList`,
        params:data
    })
}
// 文章详情接口  new-retail/owApi/article/info
export function articleInfo(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/article/info?articleClassify=${data.articleClassify}&articleId=${data.articleId}`,
    })
}

// 获取文章 分类 new-retail/owApi/article/projectClassify
export function projectClassify(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/article/projectClassify?projectType=${data}`,
    })
}

// 文章列表 new-retail/owApi/article/list
export function allArticleList(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/article/list`,
        params:data
    })
}

// 数字产品列表 new-retail/owApi/techProduct/techProductPage
export function techProductPage(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/techProduct/techProductPage',
        data
    })
}

// 数字产品详情 new-retail/owApi/techProduct/detail
export function techProductDetail(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/techProduct/detail/${data}`,
    })
}


// 通过手机号获取用户简要信息 /owApi/pay/userInfo_byMobile
export function userInfoByMobile(data) {
    return axiosInstance({
        method: 'get',
        url: `/new-retail/owApi/pay/userInfo_byMobile?mobile=${data.mobile}&aseSign=${data.aseSign}&sendTime=${data.sendTime}`,
    })
}

//下单购买数字产品
export function buyTechProduct(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/techProduct/buyTechProduct',
        data
    })
}


//订单支付   /owApi/techProduct/payTechProduct 
export function payTechProduct(data) {
    return axiosInstance({
        method: 'post',
        url: '/new-retail/owApi/techProduct/payTechProduct',
        data
    })
}

// 模板列表接口 
// export function fenceList(data) {
//     return axiosInstance({
//         method: 'get',
//         url: 'agent/fence/list',
//         data
//     })
// }

// // 查询模板推荐信息agent/fence/getinviteinfo
// export function fenceGetinviteinfo(data) {
//     return axiosInstance({
//         method: 'post',
//         url: 'agent/fence/getinviteinfo',
// 		data
//     })
// }

